export var RecurrencePattern;
(function (RecurrencePattern) {
    RecurrencePattern["DAILY"] = "daily";
    RecurrencePattern["WEEKLY"] = "weekly";
    RecurrencePattern["MONTHLY"] = "monthly";
    RecurrencePattern["CUSTOM_DAYS"] = "custom_days";
})(RecurrencePattern || (RecurrencePattern = {}));
